export default __webpack_public_path__ + "static/media/puliyogare_gojju.d4bd0dfc.png";